import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  MenuItem,
  Select,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { ExportToCsv } from 'export-to-csv';

const tableStyle = {
  minWidth: 650, // Adjust the width as needed
};

const columns = [
  {
    accessorKey: 'name',
    header: 'Name',
    size: 20,
  },
  {
    accessorKey: 'regNumber',
    header: 'Reg / Ref No.',
    size: 100,
  },
  {
    accessorKey: 'foreignClient',
    header: 'Foreign Client',
    size: 100,
  },
  {
    accessorKey: 'appliedPosition1',
    header: 'Applied Position',
    size: 100,
  },
  {
    accessorKey: 'paymentStatus',
    header: 'Payment Status',
    size: 100,
  },
  {
    accessorKey: 'paymentMethod',
    header: 'Payment Method',
    size: 100,
  },
  {
    accessorKey: 'tmeCreated',
    header: 'Date Registered',
    size: 100,
  },
  {
    accessorKey: 'remark',
    header: 'Remark',
    size: 100,
  },
];

const csvOptions = {
  fieldSeparator: ',',
  quoteStrings: '"',
  decimalSeparator: '.',
  showLabels: true,
  useBom: true,
  useKeysAsHeaders: false,
  headers: columns.map((c) => c.header),
};

const RegistrationReport = (props) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    if (Array.isArray(props?.inquiries?.inquiries)) {
      setData(props.inquiries?.inquiries);
      setLoading(false);
    }
  }, [props]);

  const handleExportRows = (rows) => {
    const csvExporter = new ExportToCsv({
      ...csvOptions,
      title: 'Registration Report',
    });
    csvExporter.generateCsv(rows.map((row) => row.original));
  };

  const handleExportData = () => {
    const columnsToExport = columns.map((col) => col.accessorKey);
    const exportData = filterDataByMonth().map((row) => {
      const rowData = {};
      columnsToExport.forEach((colKey) => {
        rowData[colKey] = row[colKey];
      });
      return rowData;
    });

    const csvExporter = new ExportToCsv({
      ...csvOptions,
      title: 'Registration Report',
      filename: 'registration_report',
    });
    csvExporter.generateCsv(exportData);
  };

  const filterDataByMonth = () => {
    const filteredData = data.filter((row) => {
      const date = new Date(row.tmeCreated);
      const month = date.getMonth() + 1;
      return month.toString() === selectedMonth;
    });

    const searchFilteredData = filteredData.filter((row) => {
      return Object.values(row).some(
        (value) => String(value).toLowerCase().includes(searchQuery.toLowerCase())
      );
    });

    const sortedData = searchFilteredData.sort((a, b) => {
      const dateA = new Date(a.tmeCreated);
      const dateB = new Date(b.tmeCreated);
      return dateA - dateB;
    });

    return sortedData;
  };

  return (
    <>
      <Box style={{ margin: 10 }}>
        <Select
          value={selectedMonth}
          size="small"
          style={{
            marginRight: 10,
          }}
          onChange={(e) => setSelectedMonth(e.target.value)}
          displayEmpty
          inputProps={{ 'aria-label': 'Select Month' }}
        >
          <MenuItem value="">Select Month</MenuItem>
          <MenuItem value="1">January</MenuItem>
          <MenuItem value="2">February</MenuItem>
          <MenuItem value="3">March</MenuItem>
          <MenuItem value="4">April</MenuItem>
          <MenuItem value="5">May</MenuItem>
          <MenuItem value="6">June</MenuItem>
          <MenuItem value="7">July</MenuItem>
          <MenuItem value="8">August</MenuItem>
          <MenuItem value="9">September</MenuItem>
          <MenuItem value="10">October</MenuItem>
          <MenuItem value="11">November</MenuItem>
          <MenuItem value="12">December</MenuItem>
        </Select>

        <TextField
          size="small"
          label="Search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            marginRight: 10,
          }}
        />

        <Button size='small' variant="contained" onClick={handleExportData} 
          style={{
            marginRight: 10,
          }}
        >
          Export CSV
        </Button>

        Total Registrations: {filterDataByMonth()?.length}
      </Box>

      {!loading && data && (
        <TableContainer component={Paper}>
          <Table style={tableStyle}>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell key={column.accessorKey}>{column.header}</TableCell>
                ))}

              </TableRow>
            </TableHead>
            <TableBody>
              {filterDataByMonth()?.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {columns.map((column) => (
                    <TableCell key={column.accessorKey}>{row[column.accessorKey]}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
};

export default RegistrationReport;
